import { PostTag, PostTagFilters, QueryResult } from '@/type';
import api from '../API';

export default {
  findAll(clientId: number, filters: PostTagFilters = {}): Promise<QueryResult<PostTag>> {
    return api
      .get(`clients/${clientId}/post-tags`, { params: filters })
      .then(response => response.data);
  },
};
